/**
 * Strips all HTML tags, styles, scripts, and entities from an HTML string,
 * returning only the plain text content.
 *
 * @param html - The HTML content to strip.
 * @returns The plain text content.
 */
const stripTextFromHtmlClientSide = (html: string | undefined): string => {
    if (!html) return '';
    try {
        // Step 1: Create a DOMParser instance to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Step 2: Remove all <script>, <style>, and <noscript> elements
        const elementsToRemove = ['script', 'style', 'noscript'];
        elementsToRemove.forEach(selector => {
            const elements = doc.querySelectorAll(selector);
            elements.forEach(el => el.remove());
        });

        // Step 3: Extract the text content from the cleaned DOM
        let textContent = doc.body.textContent || '';

        // Step 4: Normalize whitespace—replace multiple spaces, tabs, and newlines with a single space
        textContent = textContent.replace(/\s+/g, ' ').trim();

        return textContent;
    } catch (error) {
        console.error('Error stripping text from HTML:', error);
        return '';
    }
};

export { stripTextFromHtmlClientSide };
